import {useTranslation} from "react-i18next";
import {cargoSubtype, ContainerStatusEntity, transportCategory, TransportCategory} from "@ots-frontend/ots-data";
import {InsightEmpty} from "../InsightEmpty/InsightEmpty";
import {InsightChartContainerProps} from "../InsightChartContainer/InsightChartContainer";
import {InsightContainer} from "../InsightContainer/InsightContainer";
import {ContainerStatusDataTable} from "../../data-table/ContainerStatusDataTable/ContainerStatusDataTable";
import {useMemo} from "react";

export type WarningStatusContainersInsightProps = Omit<InsightChartContainerProps, 'children' | 'title' | 'icon'> & {
  value?: ContainerStatusEntity[],
  category?: TransportCategory,
  loading?: boolean
}

export const WarningStatusContainersInsight = (props: WarningStatusContainersInsightProps) => {
  const {
    value,
    category,
    loading = false,
    ...rest
  } = props

  const {t} = useTranslation()

  const title = useMemo(() => {
    return t("common.insight.warningstatuscontainers", "Warning - Container Levels")
  }, [t])

  if (!value || value.length === 0) {
    return (
      <InsightEmpty {...rest} title={title}/>
    )
  }

  return (
    <InsightContainer
      {...rest}
      title={title}
      icon={"chartHistogram"}>
      <ContainerStatusDataTable
        mt={25}
        withBorder
        records={value}
        recordsPerPageOptions={[5]}
        fetching={loading}
        columns={{
          route: true,
          site: true,
          level: true,
          secondaryLevel: category ? (category === transportCategory.water ? cargoSubtype.oil : cargoSubtype.water) : undefined,
          reject: true,
        }}/>
    </InsightContainer>
  )
}
